function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#231F20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 0H6.1v4.8H18c.7 0 1.2.5 1.2 1.2v12c0 .7-.5 1.2-1.2 1.2H6c-.4 0-.7-.2-.8-.4-.2-.1-.4-.4-.4-.8V6c0-.7.5-1.2 1.2-1.2V0C2.7 0 0 2.6 0 6v12c0 3.3 2.7 6 6 6h11.9c3.3 0 6-2.7 6-6V6c.1-3.3-2.6-6-5.9-6z"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(-.922 8.9 9.4)",
  cx: 8.9,
  cy: 9.4,
  r: 1.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.3 10.8c-.3-.5-.8-.5-1.1 0L11.8 13c-.2.3-.5.3-.7.1l-.4-.4c-.3-.3-.7-.3-1 0l-2.2 2.2c-.6.6-.4 1.2.5 1.1h8.5c.7 0 .9-.5.6-1l-2.8-4.2z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;